<template>
  <div class="left-container">
    <div
      class=" p-4 flex-column justify-content-between align-items-center text-white d-none d-md-flex d-sm-flex h-100"
    >
      <div style="align-self:start; margin-top: 25px;">
        <img
          id="login-logo"
          height="60"
          :src="
            require('../../assets/logos/Logo With EHR & Moto - No BG- Negative.png')
          "
        />
      </div>

      <div class="text-center" style="max-width: 500px">
        <img
          :src="require('../../assets/login-laptop.png')"
          style="width:100%"
        />
        <div style="font-size:26px; margin-top: -33px;">
          Electronic Health Record System
        </div>
      </div>
      <div class="end-text text-center text-white">
        <small class="text-uppercase font-weight-lighter">
          2015-{{ new Date().getFullYear() }} Opus Behavioral Health </small
        ><br />
        <small class="text-uppercase font-weight-lighter">
          © All rights reserved
        </small>
      </div>
    </div>

    <loading-overlay />
    <dialog-error />
  </div>
</template>

<script>
import LoadingOverlay from "../workspace/LoadingOverlay.vue";
import DialogError from "../controls/DialogError.vue";
export default {
  name: "AuthLeftContainer",
  components: { DialogError, LoadingOverlay }
};
</script>
<style scoped>
.left-container {
  background-size: contain;
  background-repeat: no-repeat;
  width: 50%;
  background-color: #363abb;
  padding: 0px 50px;
}
.end-text {
  padding: 0px 15%;
}
.text-ehr {
  margin-bottom: -5px;
  margin-left: 10px;
}
</style>
